var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgG(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 36,
    viewBox: "0 0 29 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6_66)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.6875 30.6875C27.4219 32.2031 25.6328 33.3828 23.3203 34.2266C21.0078 35.0547 18.4453 35.4688 15.6328 35.4688C12.6797 35.4688 10.0859 34.8281 7.85156 33.5469C5.63281 32.25 3.91406 30.375 2.69531 27.9219C1.49219 25.4688 0.875 22.5859 0.84375 19.2734V16.9531C0.84375 13.5469 1.41406 10.6016 2.55469 8.11719C3.71094 5.61719 5.36719 3.71094 7.52344 2.39844C9.69531 1.07031 12.2344 0.40625 15.1406 0.40625C19.1875 0.40625 22.3516 1.375 24.6328 3.3125C26.9141 5.23438 28.2656 8.03906 28.6875 11.7266H21.8438C21.5312 9.77344 20.8359 8.34375 19.7578 7.4375C18.6953 6.53125 17.2266 6.07812 15.3516 6.07812C12.9609 6.07812 11.1406 6.97656 9.89062 8.77344C8.64062 10.5703 8.00781 13.2422 7.99219 16.7891V18.9688C7.99219 22.5469 8.67188 25.25 10.0312 27.0781C11.3906 28.9062 13.3828 29.8203 16.0078 29.8203C18.6484 29.8203 20.5312 29.2578 21.6562 28.1328V22.25H15.2578V17.0703H28.6875V30.6875Z",
    fill: "url(#paint0_linear_6_66)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6_66",
    x1: 14.7656,
    y1: 0.40625,
    x2: 14.7656,
    y2: 35.4688,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3477DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A9AE3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6_66"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgG);
export default __webpack_public_path__ + "static/media/G.05b6deac6fec93b31b7d24d122e5c3fd.svg";
export { ForwardRef as ReactComponent };